import { useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { BloqueState, setBloque } from '../../store/slices/bloque';
// LaTeX
import Latex from 'react-latex-next';
// mui components
import { IconButton } from '@mui/material';
// mui icons
import AddIcon from '@mui/icons-material/Add';
// componentes propios
import CrearBloque from './CrearBloque';
import EliminarBloque from './EliminarBloque';
import EditarBloque from './EditarBloque';
import SeccionesEdicion from '../Secciones/SeccionesEdiciones';
import MenuBloque from './MenuBloque';
import CrearSeccion from '../Secciones/CrearSeccion';

const BloquesEdicion = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { bloques, isLoading } = useSelector((state: RootState) => state.bloque);

  // Crear Seccion
  const [openCrearSeccion, setOpenCrearSeccion] = useState(false);

  const handleClickOpenCrearSeccion = (bloque: BloqueState) => {
    dispatch(setBloque(bloque));
    setOpenCrearSeccion(true);
  }

  // Crear Bloque
  const [openCrear, setOpenCrear] = useState(false);

  const handleClickOpenCrear = () => {
    setOpenCrear(true);
  };

  // Eliminar Bloque
  const [openEliminar, setOpenEliminar] = useState(false);

  const handleEliminarBloque = (bloque: BloqueState) => {
    dispatch(setBloque(bloque));
    setOpenEliminar(true)
  }

  // Editar Bloque
  const [openEditar, setOpenEditar] = useState(false);

  const handleEditarBloque = (bloque: BloqueState) => {
    dispatch(setBloque(bloque));
    setOpenEditar(true)
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div>

      {
        openCrearSeccion && <CrearSeccion open={openCrearSeccion} setOpen={setOpenCrearSeccion}/>
      }

      {
        openCrear && <CrearBloque open={openCrear} setOpen={setOpenCrear} />
      }

      {
        openEliminar && <EliminarBloque open={openEliminar} setOpen={setOpenEliminar} />
      }

      {
        openEditar && <EditarBloque open={openEditar} setOpen={setOpenEditar} />
      }

      <div className="container mb-4">
        <div className="row justify-content-end align-items-center">
          <div className="col-auto px-1" >
            <IconButton
              onClick={handleClickOpenCrear}
              size="small"
            >
              <AddIcon />
            </IconButton>
          </div>
          <div className="col-auto px-1">
            <span style={{ color: 'grey' }}>Crear Bloque</span>
          </div>
        </div>
      </div>

      {
        bloques.map(item => {
          const { bid, nombre } = item;
          return (
            <div
              key={bid}
              className='card mb-4'
              style={{ boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.3)' }}
            >
              <div className="card-header">
                <div className="row justify-content-between align-items-center my-0">
                  <div className="col-auto">
                    <Latex>{`<span style="font-size:1.1em"}}>${nombre}</span>`}</Latex>
                  </div>
                  <div className="col-auto">
                    <MenuBloque
                      bloque={item}
                      handleClickOpenCrearSeccion={handleClickOpenCrearSeccion}
                      handleEliminarBloque={handleEliminarBloque}
                      handleEditarBloque={handleEditarBloque}
                    />
                  </div>
                </div>

              </div>

              <SeccionesEdicion bloque={item} />

            </div>
          )
        })
      }
    </div>
  )
}

export default BloquesEdicion;